module.exports = __webpack_public_path__ + "img/wine-placeholder-blank.2355cfba.png";